import React from 'react';

const ConsoleLogsSection = ({ consoleLogs, consoleLogLevelSummary, onViewAll }) => {
    if (consoleLogs.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px'
            }}>
                <h4 style={{ color: '#e0e0e0', fontWeight: '600', margin: 0 }}>
                    Console Logs
                </h4>
                <button
                    onClick={onViewAll}
                    style={{
                        backgroundColor: '#3a3a3a',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '8px 14px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '600'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#4a4a4a'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3a3a3a'}
                >
                    View all logs
                </button>
            </div>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
            }}>
                {consoleLogLevelSummary.length > 0 && (
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        flexWrap: 'wrap'
                    }}>
                        {consoleLogLevelSummary.map(({ key, label, count, color }) => (
                            <div
                                key={key}
                                style={{
                                    backgroundColor: '#262626',
                                    border: '1px solid #373737',
                                    borderRadius: '16px',
                                    padding: '6px 12px',
                                    fontSize: '12px',
                                    color,
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase',
                                    fontWeight: '600'
                                }}
                            >
                                {label}: {count}
                            </div>
                        ))}
                    </div>
                )}

                <div style={{
                    fontSize: '12px',
                    color: '#a0a0a0'
                }}>
                    Total logs: {consoleLogs.length}
                </div>
            </div>
        </div>
    );
};

export default ConsoleLogsSection;






